import { useTranslation } from 'react-i18next';
import { useTheme, Box, Typography, Divider, Stack, Modal, Button } from '@mui/material';
import { useUnsavedChangesWarning, useWorkflow } from '@frontend/features/workflows/components/WorkflowContext/hook';
import { LoadingButton } from '@mui/lab';


export const UnsavedChangesModal = () => {
  const theme = useTheme();
  const { t } = useTranslation();
  const {saveWorkflow, isLoadingWorkflow, hasWorkflowChanges, setHasWorkflowChanges } = useWorkflow();
  const { isModalOpen, handleConfirmNavigation } = useUnsavedChangesWarning(hasWorkflowChanges);

  const handleCancelation = () => {
    setHasWorkflowChanges(false);
    setTimeout(() =>  handleConfirmNavigation(), 300);
  };

  const handleSave = async () => {
    await saveWorkflow();
    setTimeout(() =>  handleConfirmNavigation(), 300);
  };

  return (
    <Modal open={isModalOpen} aria-labelledby={t('workflows.edit.title')}>
      <Box
        display="flex"
        flexDirection="column"
        gap={theme.spacing(2)}
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 400,
          bgcolor: 'background.paper',
          boxShadow: 24,
          p: theme.spacing(3),
          borderRadius: theme.spacing(2),
        }}
      >
        <Box display="flex" flexDirection="column" gap={theme.spacing(2)}>
          <Box flexGrow={1} display="flex" alignItems="center" gap={theme.spacing(1)}>
            <Typography variant="subtitle1" component="h2">
              {t('workflows.edit.unsavedChanges')}
            </Typography>
          </Box>
          <Stack gap={theme.spacing(2)}>
            <LoadingButton variant="contained" loading={isLoadingWorkflow} onClick={handleSave}>{t('common.save')}</LoadingButton>
            <Button variant="outlined" onClick={handleCancelation}>{t('common.cancel')}</Button>
          </Stack>
        </Box>
        <Divider />
      </Box>
    </Modal>
  );
};

